

export default function TextX ({content}){
    return(
        <div className="flex justify-start text-black222 font-bold leading-4">
          {content}
        </div>
    )
}